import React, { useState, useEffect, useMemo } from 'react'
import TopPart from './TopPart'
import getTopParts from '../utils/parts/getTopParts'
import { useSelector } from 'react-redux'
import { selectCurrency } from './currency/currencySlice'
import setPartsPrice from '../utils/parts/setPartsPrice'
import parts from '../utils/constants/parts'

const TopParts = () => {
    const [hide, setHide] = useState(false)

    const currency = useSelector(selectCurrency)
    const partsWithCurrency = useMemo(() => setPartsPrice(parts, currency), [currency])
    const topParts = getTopParts(partsWithCurrency, currency)

    const toggleShow = () => setHide(!hide)

    useEffect(() => {
        if (window.innerWidth <= 768) setHide('hide')
    }, [])

    return (
        <>
            {(topParts.cheapestOriginal || topParts.cheapestAnalog || topParts.fastest) && (
                <div className="top-parts">
                    {topParts.cheapestOriginal && (
                        <TopPart
                            name={'Низкая цена'}
                            icon={'price'}
                            type={'Искомый артикул'}
                            isHide={hide}
                            part={topParts.cheapestOriginal}
                        />
                    )}
                    {topParts.cheapestAnalog && (
                        <TopPart
                            name={'Низкая цена'}
                            icon={'price'}
                            type={'Аналог'}
                            isHide={hide}
                            part={topParts.cheapestAnalog}
                        />
                    )}
                    {topParts.fastest && (
                        <TopPart
                            name={'Наименьший срок'}
                            icon={'delivery'}
                            isHide={hide}
                            part={topParts.fastest}
                        />
                    )}
                    <div
                        className={
                            hide
                                ? ['top-parts__collapse-arrow', 'hide'].join(' ')
                                : 'top-parts__collapse-arrow'
                        }
                        onClick={toggleShow}
                    >
                        <svg
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z" fill="black" />
                        </svg>
                    </div>
                </div>
            )}
        </>
    )
}

export default TopParts
